import PropTypes from 'prop-types';

export const CalendarType = Object.freeze({
    DEPARTURE: 'DEPARTURE',
    RETURN: 'RETURN',
});

export const CalendarTypeProp = PropTypes.oneOf(Object.values(CalendarType));
export const CalendarTypePropDefault = CalendarType.DEPARTURE;
